/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { memo, useState } from 'react';

// custom components
import { Icon } from '../Icon';

// custom style
import style from "../../Style/Component/input.module.scss";

const CustomTextInput = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
        // props.focused();
    };

    // handle blur
    const _handleBlur = () => {
        setIsInputFocused(false);
        // props.blur();
    };

    // input handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        if (props.maxLength && value >= props.maxLength){
             return;
        }
       
        props.handleChange(value);
    };

    // handle toggle
    const _handleToggle = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13) {
            props.onKeyPress();
        }
    };

    // handle key down
    const _handleKeyDown = (e) => {
        // Prevent default behavior of up and down arrow keys
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
        }
        if (props.type === "number") {
            if (e.key === '0' && props.value === '') {
                e.preventDefault();
            }
        }
        if (e.key === '.' && props.not_decimal) {
            e.preventDefault();
        }
    };


    return (
        <div className={props.wrapperClass} ref={props.ref} >
            {props.label &&
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`${style.e_input_wrapper} position-relative`}>
                <div className={` ${props.error && style.e_error_border} ${isInputFocused ? `${style.e_active} ` : `${props.inputType === 2 ? "e-border-0-5px-arsenic" : style.e_inactive} `} border-radius-8`}>
                    <input id={props.id}
                        autocomplete="off"
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type={isPasswordVisible ? 'text' : props.type}
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_input} ${props.className} ${props.showPercentage === true ? "ps-3 py-3 padding-32px-right" : "p-3"} e-primary-font border-0 border-radius-8 e-bg-white e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px `}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }}
                        onClick={props.onClick} />

                </div>

                {props.showPercentage === true &&
                    <span className='position-absolute top-14px right-12px e-text-smoky-black e-font-14 e-alt-font e-font-weight-400 line-height-24px'>
                        %
                    </span>
                }

                {
                    props.showIcon && (
                        <Icon
                            icon={isPasswordVisible ? "eye" : "eye-slash"}
                            size="1rem"
                            className="d-flex position-absolute top-18px right-12px cursor-pointer"
                            onClick={_handleToggle}
                        />
                    )
                }


                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

CustomTextInput.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
    value: "",
    showPercentage: false
}

export default memo(CustomTextInput);